import React, { PureComponent } from 'react'
import Button from 'aria-viewer/tour/components/buttons/button'
import Icon from 'aria-viewer/tour/components/icon'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { closeModal } from 'aria-viewer/modal/modalActions'
import { connect } from 'react-redux'
import pure from 'recompose/pure'

const S = {
    modalTitle: Object.assign({}, styleguide.modals.title, {
        margin: 0,
    }),
    modalBody: styleguide.modals.body,
    modalSubmitButton: Object.assign({}, styleguide.modals.submitButton.style, {
        position: 'absolute',
        bottom: '0',
        left: '50%',
        transform: 'translate3d(-50%,50%,0)',
        margin: '0',
        width: '80%',
    }),
}

const SubmitButton = pure(function SubmitButton({ label, onSubmitButtonClick }) {
    return (
        <Button onClick={onSubmitButtonClick} theme="shareModalButton" style={S.modalSubmitButton}>
            {label}
        </Button>
    )
})

const ModalTitle = pure(function ModalTitle({ title }) {
    return <p style={S.modalTitle}>{title}</p>
})

const ModalIcon = pure(function ModalIcon({ iconStyle, icon }) {
    return <Icon style={iconStyle} icon={icon} />
})

const ModalBody = pure(function ModalBody({ body, bodyStyle }) {
    return <p style={bodyStyle ? bodyStyle : S.modalBody} dangerouslySetInnerHTML={{ __html: body }} />
})

class AlertModal extends PureComponent {
    constructor(props) {
        super(props)
    }

    onSubmitButtonClick = e => {
        const { submitAction, closeModal } = this.props

        if (submitAction) {
            if (submitAction == 'closeModal') {
                closeModal()
            } else {
                submitAction()
            }
        }
    }

    onFormContainerClick = e => {
        const { formClickAction, closeModal } = this.props

        if (formClickAction) {
            if (formClickAction == 'closeModal') {
                closeModal()
            } else {
                formClickAction()
            }
        }
    }

    render() {
        const { content } = this.props
        return (
            <div onClick={this.onFormContainerClick}>
                {content.title && <ModalTitle title={content.title} />}
                {content.icon && <ModalIcon iconStyle={content.icon.iconStyle} icon={content.icon.iconName} />}
                {content.body && <ModalBody body={content.body} bodyStyle={content.bodyStyle} />}
                {content.submit && (
                    <SubmitButton label={content.submit.label} onSubmitButtonClick={this.onSubmitButtonClick} />
                )}
            </div>
        )
    }
}

export default connect(
    null,
    { closeModal }
)(AlertModal)
